var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 16C0 7.168 7.152 0 15.984 0 24.832 0 32 7.168 32 16s-7.168 16-16.016 16C7.152 32 0 24.832 0 16m17.597-6.4c0-.88-.72-1.6-1.6-1.6s-1.6.72-1.6 1.6V16c0 .88.72 1.6 1.6 1.6s1.6-.72 1.6-1.6zm-1.589 19.198c-7.072 0-12.8-5.728-12.8-12.8s5.728-12.8 12.8-12.8 12.8 5.728 12.8 12.8-5.728 12.8-12.8 12.8m-1.61-7.997v3.2h3.2v-3.2z",
    clipRule: "evenodd"
  })));
};
export default SvgAlert;